import { render, staticRenderFns } from "./HighStateTypesDashboardStats.vue?vue&type=template&id=2322640a&scoped=true"
import script from "./HighStateTypesDashboardStats.vue?vue&type=script&lang=js"
export * from "./HighStateTypesDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./HighStateTypesDashboardStats.vue?vue&type=style&index=0&id=2322640a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2322640a",
  null
  
)

export default component.exports